module.exports = __webpack_public_path__ + "static/media/Edit.67dea1c0.svg";